<template>
    <div class="date-navigation d-flex justify-content-between align-items-center text-center mx-n2 mt-n2">
        <div class="flex-grow-1 text-left">
            <button class="btn btn-arrow" title="Previous" @click="goPrevious">
                <i class="fa fa-chevron-left"></i>
            </button>
        </div>

        <div class="flex-grow-1 text-center">
            <span class="selected-date">{{ formattedDate }}</span>
        </div>

        <div class="flex-grow-1 text-right">
            <button class="btn btn-arrow" data-placement="right" title="Next" @click="goNext">
                <i class="fa fa-chevron-right"></i>
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ToDoDateNavigation',
        props: {
            date: {
                type: String,
                default: null
            },
            role: {
                type: Number,
                default: 0
            },
            timezone: {
                type: String,
                default: 'UTC'
            }
        },
        data() {
            return {
                currentIndex: 0,
                currentDate: this.createDateFromInitial(),
                isUserAction: false // Track if the date change is from user action
            }
        },
        computed: {
            formattedDate() {
              // Always use currentDate (which gets updated with user's datetime)
              const formatted = this.currentDate.toLocaleDateString('en-US', {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              });
              
              // Remove comma before the year
              return formatted.replace(/,(?=\s\d{4})/, '');
            },
            isToday() {
              // Use server's user datetime for "today" comparison if available
              const today = new Date(this.date);
              const current = this.currentDate;
              
              return today.toDateString() === current.toDateString();
            }
        },
        watch: {
            date: {
                immediate: false,
                handler(newDate, oldDate) {
                    if (newDate && newDate !== oldDate && !this.isUserAction) {
                        this.currentDate = this.createDateFromInitial();
                    }
                }
            }
        },
        mounted() {
            this.currentDate = this.createDateFromInitial();
        },
        methods: {
            createDateFromInitial() {
                if (!this.date) {
                    return new Date();
                }
                
                // Parse the date (YYYY-MM-DD format) and create a local date
                const [year, month, day] = this.date.split('-').map(Number);
                const localDate = new Date(year, month - 1, day, 12, 0, 0);
                
                return localDate;
            },
            getTimezoneOffset() {
                if (!this.timezone || this.timezone === 'UTC') {
                    return 'Z';
                }
                
                if (this.timezone.match(/^[+-]\d{2}:\d{2}$/)) {
                    return this.timezone;
                }
                
                return 'Z';
            },
            goNext() {
                this.isUserAction = true;
                this.currentIndex++;
                this.currentDate.setDate(this.currentDate.getDate() + 1);
                this.currentDate = new Date(this.currentDate);
                this.emitCurrentDate();
                this.$nextTick(() => {
                    this.isUserAction = false;
                });
            },
            goPrevious() {
                this.isUserAction = true;
                this.currentIndex--;
                this.currentDate.setDate(this.currentDate.getDate() - 1);
                this.currentDate = new Date(this.currentDate);
                this.emitCurrentDate();
                this.$nextTick(() => {
                    this.isUserAction = false;
                });
            },
            emitCurrentDate() {
              // Format date as YYYY-MM-DD for the date-selected event
              const year = this.currentDate.getFullYear();
              const month = String(this.currentDate.getMonth() + 1).padStart(2, '0');
              const day = String(this.currentDate.getDate()).padStart(2, '0');
              const selectedDate = `${year}-${month}-${day}`;
              
            //   console.log('ToDoDateNavigation: emitting date-selected:', selectedDate);
              this.$emit('date-selected', selectedDate);
            }
        }
    }
</script>
